import { Row, Skeleton, Image, Spin } from 'antd'
import { LoadableImageProps } from './types'

const LoadableImage: React.FC<LoadableImageProps> = ({
  height,
  width,
  alt,
  loading,
  preview,
  src,
}) => {
  return (
    <Row
      justify={loading ? 'center' : 'start'}
      align={loading ? 'middle' : 'top'}
      style={{ height, width }}
    >
      <Spin spinning={loading}>
        {(loading || !src) && <Skeleton.Image style={{ height, width }} />}
      </Spin>
      {!loading && !!src && (
        <Image
          src={src}
          alt={alt ?? 'Image'}
          preview={!!src ? preview : undefined}
          height={height}
          width={width}
        />
      )}
    </Row>
  )
}

export default LoadableImage
